<template>
  <Teleport to="body">
    <div
      v-if="tip"
      class="chart-hover-tooltip"
      :style="{ left: `${tip.x}px`, top: `${tip.y}px` }"
      role="tooltip"
    >
      {{ tip.text }}
    </div>
  </Teleport>
</template>

<script setup>
defineProps({
  tip: {
    type: Object,
    default: null,
  },
});
</script>

<style>
.chart-hover-tooltip {
  position: fixed;
  z-index: 10000;
  max-width: 280px;
  padding: 6px 10px;
  border-radius: 6px;
  background: #1f2937;
  color: #fff;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;
  pointer-events: none;
  transform: translate(-50%, -100%);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  white-space: nowrap;
}
</style>
